module.exports = __webpack_public_path__ + "static/darren_2-ec34ae019271ecf5e19bf70e670afcdf.gif";